import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  GECKO_CONSTS,
  GECKO_UTILS,
  GeckoLoadingService,
  GeckoModal,
  GeckoToastService,
} from 'ui';
import { connect } from 'react-redux';
import GeckoStore from 'services/gecko-store';
import GeckoRequest from '../../../../services/gecko-request';
import GeckoLocation from '../../../../services/gecko-location';
import { renderError } from '../../../../services/gecko-error';
import { newIntegration } from '../../../../actions/integrations';

class DynamicsLoginModal extends Component {
  static propTypes = {
    values: PropTypes.object,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      chosen_module: 'contacts',
      client_id: '',
      client_secret: '',
      resource: '',
      values: {
        chosen_module: 'contacts',
      },
      application_user: false,
    };
  }

  fields = [
    {
      key: 'chosen_module',
      label: 'Choose Module Type',
      required: true,
      options: [
        {
          label: 'Contact',
          value: 'contacts',
        },
        {
          label: 'Lead',
          value: 'leads',
        },
      ],
      width: 'col-xs-12',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT,
    },
    {
      key: 'resource',
      label: 'Dynamics instance URL',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
    },
    {
      key: 'client_id',
      label: 'App ID',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
    },
    {
      key: 'client_secret',
      label: 'Password Key',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_PASSWORD,
      config: {
        autoComplete: 'new-password',
      },
    },
    {
      key: 'application_user',
      // toggle switch
      label: 'Application User',
      type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
    },
    {
      key: 'tenant_id',
      label: 'Tenant ID',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      width: '100%',
      hideWhen: () => !this.state.application_user,
    },
  ];

  footerButtons = [
    {
      name: 'Done',
      type: 'primary',
      icon: 'far fa-check',
      handler: () => {
        this.handleSubmit.bind(this)();
      },
    },
  ];

  onUserInput(key, value) {
    this.setState({
      [key]: value,
      values: Object.assign(this.state.values, { [key]: value }),
    });
  }

  createAuthorisationUrl() {
    const client_id = this.state.client_id;
    const resource = this.state.resource;
    const redirect = encodeURI(this.props.apiUrl + '/forward/dynamics');
    return `https://login.windows.net/common/oauth2/authorize?response_type=code&client_id=${client_id}&resource=${resource}&redirect_uri=${redirect}`;
  }

  handleSubmit() {
    this.state.application_user
      ? this.handleApplicationUser()
      : this.handleUser();
  }

  handleApplicationUser() {
    const validateRequired = (fields, values) => {
      return fields.reduce((valid, field) => {
        if (field.required && !GECKO_UTILS.getNestedValue(values, field.key)) {
          new GeckoToastService().error(`The ${field.label} field is required`);
          return false;
        }
        return valid;
      }, true);
    };
    const values = Object.assign({}, this.state);
    const valid = validateRequired(this.fields, values);
    if (!valid) {
      return;
    }
    // If the resource ends with a / then strip it out
    let { resource } = values;
    if (resource[resource.length - 1] === '/') {
      resource = resource.substring(0, resource.length - 1);
    }

    const newDynamicsIntegration = {
      account_id: this.props.current_user.account_id,
      configuration: {
        // get Dynamics setup details from sessionStorage, Dynamics auth code from params
        tenant_id: values.tenant_id,
        client_id: values.client_id,
        client_secret: values.client_secret,
        resource,
        chosen_module: values.chosen_module,
      },
      type: 'dynamics',
    };

    const saveIntegration = GeckoRequest.post(
      '/integration/',
      newDynamicsIntegration
    );
    new GeckoLoadingService()
      .resolve(saveIntegration)
      .then((integration) => {
        new GeckoToastService().success(`Dynamics integration created`);
        this.modal.close();
        this.props.addIntegration(integration);
        return GeckoLocation.goTo(`/settings/integration/dynamics`);
      })
      .catch(renderError);
  }

  handleUser() {
    const validateRequired = (fields, values) => {
      return fields.reduce((valid, field) => {
        if (field.required && !GECKO_UTILS.getNestedValue(values, field.key)) {
          new GeckoToastService().error(`The ${field.label} field is required`);
          return false;
        }
        return valid;
      }, true);
    };
    const values = Object.assign({}, this.state);
    const valid = validateRequired(this.fields, values);
    if (!valid) {
      return;
    }
    // If the resource ends with a / then strip it out
    let { resource } = values;
    if (resource[resource.length - 1] === '/') {
      resource = resource.substring(0, resource.length - 1);
    }
    GeckoStore.localStorage.set('dynamics_resource', resource);
    GeckoStore.localStorage.set('dynamics_client_id', values.client_id);
    GeckoStore.localStorage.set('dynamics_client_secret', values.client_secret);
    GeckoStore.localStorage.set('dynamics_chosen_module', values.chosen_module);
    window.location = this.createAuthorisationUrl();
  }

  render() {
    return (
      <GeckoModal
        ref={(elem) => (this.modal = elem)}
        name="Please enter these details:"
        fields={this.fields}
        values={this.state.values}
        btns={this.footerButtons}
        handler={this.onUserInput.bind(this)}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultHeaders: state.appState.defaultHeaders,
    current_user: state.appState.loggedInUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addIntegration: (integration) => dispatch(newIntegration(integration)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicsLoginModal);
